import { createActionThunk } from 'redux-thunk-actions'
import { createAction, handleActions } from 'redux-actions'

import api from 'core/api'

const getType = type => `@users/current/payments/${type}`

export const getPayments = createActionThunk(getType('FETCH'), api('/users/current/payments'))
export const setSearch = createAction(getType('SET_SEARCH'))

const initialState = {
  json: [],
  search: {
    page: 1,
    per_page: 5,
    payment_type: null
  }
}

export default handleActions(
  {
    [getPayments.START]: state => ({ ...state, loading: true }),
    [getPayments.SUCCEEDED]: (state, { payload }) => ({
      ...state,
      ...payload,
      headers: payload.headers
    }),
    [getPayments.ENDED]: state => ({ ...state, loading: false }),
    [setSearch]: (state, { payload }) => ({ ...state, search: { ...state.search, ...payload } })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/current/payments.js